import { ApiTalentWheelPositionDto } from "../models/api/talent";
import gigApiFetcher from "./common/fetching";

export const fetchWheelPositionList = async (accessToken?: string | null): Promise<ApiTalentWheelPositionDto[]> => {
    const response = await gigApiFetcher<never, ApiTalentWheelPositionDto[]>({
        url: "api/wheel-positions",
        method: "GET",
        body: undefined,
        token: accessToken || undefined,
    });

    return response;
};

export const fetchWheelPositionOptions = async (accessToken?: string | null) => {
    const wheelPositionResponse = await fetchWheelPositionList(accessToken);

    return wheelPositionResponse.map(wheelPosition => ({
        value: wheelPosition.id,
        label: wheelPosition.wheelPosition,
    }));
};